module.exports = __webpack_public_path__ + "07_long_brown.c539f0fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/07_long_brown.png
// module id = bQfg
// module chunks = 0